import { render, staticRenderFns } from "./ScoringTaskList.vue?vue&type=template&id=53d19dd4&scoped=true"
import script from "./ScoringTaskList.vue?vue&type=script&lang=js"
export * from "./ScoringTaskList.vue?vue&type=script&lang=js"
import style0 from "./ScoringTaskList.vue?vue&type=style&index=0&id=53d19dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@1.0.1_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d19dd4",
  null
  
)

export default component.exports